import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import { Feature, FeatureNames, ProgramCommands, ProgramProperties } from '@vi-iot/client';

import { InstallationFeaturesStore } from '@store';

import {
  HeatingPanelService,
  HEATING_PROGRAMS,
} from '../../../temperature-schedule-manager/heating-panel/heating-panel.service';

@Component({
  selector: 'app-comfort-mode-panel',
  templateUrl: './comfort-mode-panel.component.html',
  styleUrls: ['./comfort-mode-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ComfortModePanelComponent implements OnInit {
  @Input() circuitId: string;

  comfort$: Observable<Feature<ProgramProperties, ProgramCommands>>;

  constructor(
    public heatingPanelService: HeatingPanelService,
    private installationFeaturesStore: InstallationFeaturesStore
  ) {}

  ngOnInit(): void {
    this.comfort$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.circuitOperatingProgram(this.circuitId, HEATING_PROGRAMS.COMFORT)
    );
  }
}
